import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { TOP_LEVEL_CATEGORY_ID } from 'app/constants/AdminBrowseConstants';
import { FIELD_ID, FILTERS_TYPE, GROUP_ID } from 'app/constants/BrowseConstants';

// categories
export const categoryShape = PropTypes.exact({
  categoryId: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  parentCategoryId: PropTypes.string,
  searchUrl: PropTypes.string.isRequired,
  subCategoryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired
});

export const categoryIndexShape = PropTypes.objectOf(categoryShape);
export const immutableCategoryIndexShape = ImmutablePropTypes.mapOf(
  ImmutablePropTypes.mapContains({
    categoryId: PropTypes.string.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    parentCategoryId: PropTypes.string,
    searchUrl: PropTypes.string.isRequired,
    subCategoryIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired
  }),
  PropTypes.string
);

export const categoryConfigShape = PropTypes.exact({
  categoryConfigId: PropTypes.string.isRequired,
  categoryIndex: categoryIndexShape.isRequired,
  languageKey: PropTypes.string.isRequired,
  topLevelCategoryId: PropTypes.oneOf(Object.values(TOP_LEVEL_CATEGORY_ID)).isRequired,
  updatedAt: PropTypes.number.isRequired,
  updatedBy: PropTypes.string.isRequired
});

// facets
const fieldIdShape = PropTypes.oneOf(Object.values(FIELD_ID));
const groupIdShape = PropTypes.oneOf(Object.values(GROUP_ID));

export const filterShape = PropTypes.shape({
  fieldId: fieldIdShape.isRequired,
  filterId: PropTypes.string.isRequired,
  groupId: groupIdShape.isRequired,
  isApplied: PropTypes.bool.isRequired,
  isExclusive: PropTypes.bool.isRequired,
  isShown: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
});

export const groupShape = PropTypes.shape({
  groupId: groupIdShape.isRequired,
  filters: PropTypes.arrayOf(filterShape).isRequired,
  filtersType: PropTypes.oneOf(Object.values(FILTERS_TYPE)).isRequired,
  label: PropTypes.string.isRequired
});

export const fieldShape = PropTypes.shape({
  fieldId: fieldIdShape.isRequired,
  hasMore: PropTypes.bool.isRequired,
  groups: PropTypes.arrayOf(groupShape).isRequired,
  isHidden: PropTypes.bool.isRequired,
  isInitiallyExpanded: PropTypes.bool.isRequired,
  isShowingMore: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  numAppliedFilters: PropTypes.number.isRequired,
  renderContentBeforeGroups: PropTypes.func.isRequired,
  showMoreOverlayTitle: PropTypes.string.isRequired
});
